import { Dispatch } from 'redux';
import { Weddings } from '@bridebook/models';
import { getDocsFromCacheOrServer } from '@bridebook/web/lib/auth/utils/get-docs-from-cache-or-server';
import { onFirebaseBudget } from '@bridebook/web/lib/budget/actions/on-listener';
import { recursiveOmitMutableTimestamps } from '@bridebook/web/lib/utils';
import type { TCostSerialized } from '@bridebook/web/lib/weddings/types';
import { recursiveSerializeTimestamps } from '@bridebook/toolbox/src/serialize-timestamps';

export const fetchBudgetData = async (dispatch: Dispatch<any>, weddingId: string) => {
  const weddingCostsRef = Weddings._.getById(weddingId).Costs.reference;
  const weddingCostsSnapshot = await getDocsFromCacheOrServer(weddingCostsRef);
  const weddingCostsData: Record<string, TCostSerialized> = {};
  weddingCostsSnapshot.docs.forEach((doc) => {
    weddingCostsData[doc.id] = recursiveOmitMutableTimestamps(
      recursiveSerializeTimestamps(doc.data()),
    );
  });

  dispatch(onFirebaseBudget(weddingCostsData));
};
